import { SdkLanguage } from '@ondato-public/idv-sdk'

export enum FieldName {
  FirstName = 'first_name',
  LastName = 'last_name',
  Birthdate = 'birthdate',
  Nationality = 'nationality',
  SsnSerial = 'ssn_serial',
  PersonalIdNumber = 'personal_id_number',
  Address = 'address',
  IdentityDocument = 'identity_document',
  RegistrationNumber = 'registration_number',
  BusinessAddress = 'business_address',
  Ubo = 'ubos',
}

export enum Status {
  Unverified = 'unverified',
  Verifying = 'verifying',
  Verified = 'verified',
  VerificationFailed = 'verification_failed',
  VerificationBlocked = 'verification_blocked',
}

export const vintedOndatoLocaleMap: Record<string, SdkLanguage> = {
  en: SdkLanguage.EnGb,
  lt: SdkLanguage.LtLt,
  de: SdkLanguage.DeDe,
  cz: SdkLanguage.CsCz,
  es: SdkLanguage.EsEs,
  fr: SdkLanguage.FrFr,
  nl: SdkLanguage.NlNl,
  pl: SdkLanguage.PlPl,
  'bg-bg': SdkLanguage.BgBg,
  'ca-es': SdkLanguage.CaEs,
  'cs-cz': SdkLanguage.CsCz,
  'de-de': SdkLanguage.DeDe,
  'en-gb': SdkLanguage.EnGb,
  'es-es': SdkLanguage.EsEs,
  'et-ee': SdkLanguage.EtEe,
  'fr-fr': SdkLanguage.FrFr,
  'lt-lt': SdkLanguage.LtLt,
  'lv-lv': SdkLanguage.LvLv,
  'nl-nl': SdkLanguage.NlNl,
  'pl-pl': SdkLanguage.PlPl,
  'pt-br': SdkLanguage.PtBr,
  'ro-ro': SdkLanguage.RoRo,
  'ru-ru': SdkLanguage.RuRu,
  'sq-al': SdkLanguage.SqAl,
  'uk-ua': SdkLanguage.UkUa,
}

export enum SupportingDocumentType {
  BankStatement = 'bank_statement',
  AddressProof = 'proof_of_residency',
}

export enum TipType {
  DocumentUpload = 'document_upload_requirements',
  AddressProof = 'proof_of_address_requirements',
  BankStatement = 'bank_statement_requirements',
}

export enum ActionButtonTypes {
  Submit = 'submit',
  Continue = 'continue',
}

export enum OndatoWebSdkState {
  LoadSuccess = 'load_success',
  LoadFail = 'load_fail',
  LoadException = 'load_exception',
  BeginSuccess = 'begin_success',
  BeginException = 'begin_exception',
  EndSuccess = 'end_success',
  EndException = 'end_exception',
}
